export default __webpack_public_path__ + "static/media/panel-principal-proveedor.3775aff0.svg";